<template>
  <div
    class="flex items-center gap-2 px-2 py-1 bg-white rounded-md cursor-pointer select-none"
    @click="$refs.levelCurtain.tab('default/details')"
  >
    <t-text size="md" color="gray" class="font-semibold" v-if="hasText">{{ text[level] }}</t-text>
    <div class="flex gap-1">
      <div
        class="w-3 h-3 rounded-full"
        :class="{
          'bg-platinum': i > level,
          'bg-red': i <= level && level === 1,
          'bg-orange': i <= level && level === 2,
          'bg-green': i <= level && level > 2
        }"
        v-for="i in 5"
        :key="i"
      />
    </div>
    <!-- CURTAIN -->
    <t-curtain ref="levelCurtain">
      <t-curtain-tab
        group="default"
        name="details"
        :fullscreen="isDesktop"
        :historyMode="false"
        :hasClose="true"
        title="Networking Activity Indicator"
      >
        <div class="flex flex-col gap-8">
          <div class="flex flex-col gap-1">
            <div class="flex items-center gap-2">
              <t-text color="black" size="xl" class="font-semibold">Inactive</t-text>
              <div class="flex gap-1">
                <div class="w-3 h-3 rounded-full" :class="{'bg-platinum': i > 1, 'bg-red': i <= 1}" v-for="i in 5" :key="i" />
              </div>
            </div>
            <t-text color="black">{{ $t('components.networking.level.1') }}</t-text>
          </div>
          <div class="flex flex-col gap-1">
            <div class="flex items-center gap-2">
              <t-text color="black" size="xl" class="font-semibold">Passive</t-text>
              <div class="flex gap-1">
                <div class="w-3 h-3 rounded-full" :class="{'bg-platinum': i > 2, 'bg-orange': i <= 2}" v-for="i in 5" :key="i" />
              </div>
            </div>
            <t-text color="black">{{ $t('components.networking.level.2') }}</t-text>
          </div>
          <div class="flex flex-col gap-1">
            <div class="flex items-center gap-2">
              <t-text color="black" size="xl" class="font-semibold">Ready Network</t-text>
              <div class="flex gap-1">
                <div class="w-3 h-3 rounded-full" :class="{'bg-platinum': i > 3, 'bg-green': i <= 3}" v-for="i in 5" :key="i" />
              </div>
            </div>
            <t-text color="black">{{ $t('components.networking.level.3') }}</t-text>
          </div>
          <div class="flex flex-col gap-1">
            <div class="flex items-center gap-2">
              <t-text color="black" size="xl" class="font-semibold">Rising Star</t-text>
              <div class="flex gap-1">
                <div class="w-3 h-3 rounded-full" :class="{'bg-platinum': i > 4, 'bg-green': i <= 4}" v-for="i in 5" :key="i" />
              </div>
            </div>
            <t-text color="black">{{ $t('components.networking.level.4') }}</t-text>
          </div>
          <div class="flex flex-col gap-1">
            <div class="flex items-center gap-2">
              <t-text color="black" size="xl" class="font-semibold">Legend</t-text>
              <div class="flex gap-1">
                <div class="w-3 h-3 rounded-full" :class="{'bg-platinum': i > 5, 'bg-green': i <= 5}" v-for="i in 5" :key="i" />
              </div>
            </div>
            <t-text color="black">{{ $t('components.networking.level.5') }}</t-text>
          </div>
        </div>
      </t-curtain-tab>
    </t-curtain>
  </div>
</template>

<script>
  import handleViewport from '@/utils/mixins/handleViewport'
  export default {
    name: 't-user-level',
    props: {
      hasText: {
        type: Boolean,
        default: false
      },
      level: {
        type: Number,
        required: true
      }
    },
    mixins: [handleViewport],
    data() {
      return {
        text: ['', 'Inactive', 'Passive', 'Ready Network', 'Rising Star', 'Legend']
      }
    }
  }
</script>
